import {TGrn} from './t-grn';
import {MItem} from '../../../service/m-item/model/m-item';

export class TGrnItem {

  indexNo: number;
  purchaseOrderItem: number = 0;
  price: number = 0;
  qty: number = 0;
  value: number = 0;
  discount: number = 0;
  discountValue: number = 0;
  netValue: number = 0;
  grn: TGrn;
  item: MItem;
  //temp
  stock: number = 0;
  itemBarcode:string;
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-grn/model/t-grn-item.ts